import servicePurpose1 from 'assets/service-purpose-1.svg'
import servicePurpose2 from 'assets/service-purpose-2.svg'
import servicePurpose3 from 'assets/service-purpose-3.svg'
import servicePurpose10 from 'assets/services-icons-no-box/brows.svg'

/** Small icon next to a service name, by the service's API type */
export const getServiceTypeIcon = (type: number): string => {
  switch (type) {
    case 2:
    case 9:
      return servicePurpose2
    case 3:
    case 7:
      return servicePurpose3
    case 10:
      return servicePurpose10
    default:
      return servicePurpose1
  }
}
